import { render, staticRenderFns } from "./FactoringInfo.vue?vue&type=template&id=0824319a&lang=pug"
import script from "./FactoringInfo.vue?vue&type=script&lang=ts"
export * from "./FactoringInfo.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports